const shoulder_questions = [
   {
      "question":"How is ##name## being evaluated today?",
      "sub":"",
      "type":"radio",
      "telehealth":"form1[0].#subform[0].HowExamCOnducted[0]",
      "show": true,
      "section": {
         page: "1",
         title: "Disability Benefits Questionnaire",
         number: "0"
      },
      "questions":[
         {
            "label":"How was the examination conducted?",
            "title":"",
            "subMain":"",
            "sub":"",
            "radioGroup":"form1[0].#subform[0].RadioButtonList[3]",
            "options":[
               {
                  "main":"In-Person Exam",
                  "dbqName":"1",
                  "sub":""
               },
               {
                  "main":"Video Telehealth",
                  "dbqName":"2",
                  "sub":""
               }
            ],
            "answer":"In-Person Exam"
         }
      ]
   },
   {
      "question":"Is ##name## regularly seen as a patient in your clinic?",
      "sub":"",
      "type":"yesno",
      "show": true,
      "section": {
         page: "1",
         title: "Disability Benefits Questionnaire",
         number: "0"
      },
      "presidence":"Yes",
      "radioGroup":"form1[0].#subform[0].RadioButtonList[2]",
      "ref":0,
      "dbqName_yes":"1",
      "dbqName_no":"2",
      "answer":"",
   },
   {
      "question":"Did you review any of the patients records for this condition?",
      "sub":"",
      "type":"yesno",
      "show": true,
      "section": {
         page: "1",
         title: "Disability Benefits Questionnaire",
         number: "0"
      },
      "presidence":"Yes",
      "radioGroup":"form1[0].#subform[0].RadioButtonList[0]",
      "ref":0,
      "dbqName_yes":"2",
      "dbqName_no":"1",
      "answer":"",
      "istext": true,
      "textarea": false,
      "placeholder": "Please identify the evidence reviewed and the date range",
      "textdbqName":"form1[0].#subform[0].IdentifyEvidence[0]",
      "textanswer":""
   },
   {
      "question":"Initial Range of Motion (ROM) Measurements for ##redHeading##",
      "redHeading": "Right Shoulder",
      "sub":"",
      "type":"text",
      "show": true,
      "section": {
         page: "4",
         title: "ROM AND FUNCTIONAL LIMITATION",
         number: "3A"
      },
      "questions":[
         {
            "main":"Flexion",
            "subMain":"Normal Endpoint is 180 Degrees",
            "sub":"Post-Test ROM Measurement",
            "type":"select",
            "dbqName":"form1[0].#subform[4].TextField6[100]",
            "defaultVal":"180",
            "values":["180", "175", "170", "165", "160", "155", "150", "145", "140", "135", "130", "125", "120", "115", "110", "105", "100", "95", "90", "85", "80", "75", "70", "65", "60", "55", "50", "45", "40", "35", "30", "25", "20", "15", "10", "5"],
            "answer":"180"
         },
         {
            "main":"Abduction",
            "subMain":"Normal Endpoint is 180 Degrees",
            "sub":"Post-Test ROM Measurement",
            "type":"select",
            "dbqName":"form1[0].#subform[4].TextField6[101]",
            "defaultVal":"180",
            "values":["180", "175", "170", "165", "160", "155", "150", "145", "140", "135", "130", "125", "120", "115", "110", "105", "100", "95", "90", "85", "80", "75", "70", "65", "60", "55", "50", "45", "40", "35", "30", "25", "20", "15", "10", "5"],
            "answer":"180"
         },
         {
            "main":"Internal Rotation",
            "subMain":"Normal Endpoint is 90 Degrees",
            "sub":"Post-Test ROM Measurement",
            "type":"select",
            "dbqName":"form1[0].#subform[4].TextField6[102]",
            "defaultVal":"90",
            "values":["90", "85", "80", "75", "70", "65", "60", "55", "50", "45", "40", "35", "30", "25", "20", "15", "10", "5"],
            "answer":"90"
         },
         {
            "main":"External Rotation",
            "subMain":"Normal Endpoint is 90 Degrees",
            "sub":"Post-Test ROM Measurement",
            "type":"select",
            "dbqName":"form1[0].#subform[4].TextField6[103]",
            "defaultVal":"90",
            "values":["90", "85", "80", "75", "70", "65", "60", "55", "50", "45", "40", "35", "30", "25", "20", "15", "10", "5"],
            "answer":"90"
         }
      ]
   },
   {
      "question":"Initial Range of Motion (ROM) Measurements for ##redHeading##",
      "redHeading": "Left Shoulder",
      "sub":"",
      "type":"text",
      "show": true,
      "section": {
         page: "4",
         title: "ROM AND FUNCTIONAL LIMITATION",
         number: "3A"
      },
      "questions":[
         {
            "main":"Flexion",
            "subMain":"Normal Endpoint is 180 Degrees",
            "sub":"Post-Test ROM Measurement",
            "type":"select",
            "dbqName":"form1[0].#subform[4].TextField6[104]",
            "defaultVal":"180",
            "values":["180", "175", "170", "165", "160", "155", "150", "145", "140", "135", "130", "125", "120", "115", "110", "105", "100", "95", "90", "85", "80", "75", "70", "65", "60", "55", "50", "45", "40", "35", "30", "25", "20", "15", "10", "5"],
            "answer":"180"
         },
         {
            "main":"Abduction",
            "subMain":"Normal Endpoint is 180 Degrees",
            "sub":"Post-Test ROM Measurement",
            "type":"select",
            "dbqName":"form1[0].#subform[4].TextField6[105]",
            "defaultVal":"180",
            "values":["180", "175", "170", "165", "160", "155", "150", "145", "140", "135", "130", "125", "120", "115", "110", "105", "100", "95", "90", "85", "80", "75", "70", "65", "60", "55", "50", "45", "40", "35", "30", "25", "20", "15", "10", "5"],
            "answer":"180"
         },
         {
            "main":"Internal Rotation",
            "subMain":"Normal Endpoint is 90 Degrees",
            "sub":"Post-Test ROM Measurement",
            "type":"select",
            "dbqName":"form1[0].#subform[4].TextField6[106]",
            "defaultVal":"90",
            "values":["90", "85", "80", "75", "70", "65", "60", "55", "50", "45", "40", "35", "30", "25", "20", "15", "10", "5"],
            "answer":"90"
         },
         {
            "main":"External Rotation",
            "subMain":"Normal Endpoint is 90 Degrees",
            "sub":"Post-Test ROM Measurement",
            "type":"select",
            "dbqName":"form1[0].#subform[4].TextField6[107]",
            "defaultVal":"90",
            "values":["90", "85", "80", "75", "70", "65", "60", "55", "50", "45", "40", "35", "30", "25", "20", "15", "10", "5"],
            "answer":"90"
         }
      ]
   },
   {
      "question":"Which ROM exhibited pain for ##redHeading##?",
      "redHeading" : "Right Shoulder",
      "sub":"Check all that apply",
      "type":"radioTiles",
      "multi": true,
      "show": true,
      "section": {
         page: "4",
         title: "ROM AND FUNCTIONAL LIMITATION",
         number: "3A"
      },
      "small": true,
      "partial": true,
      "cols": 2,
      "questions":[
         {
            "main":"Flexion",
            "dbqName":"form1[0].#subform[4].CheckBox37[24]",
            "answer":""
         },
         {
            "main":"Abduction",
            "dbqName":"form1[0].#subform[4].CheckBox37[25]",
            "answer":""
         },
         {
            "main":"Internal Rotation",
            "dbqName":"form1[0].#subform[4].CheckBox37[34]",
            "answer":""
         },
         {
            "main":"External Rotation",
            "dbqName":"form1[0].#subform[4].CheckBox37[35]",
            "answer":""
         },
         {
            "main":"None",
            "dbqName":"pass_this_question",
            "partialField": true,
            "answer":""
         }            
      ],
      "answer":""
   },
   {
      "question":"Which ROM exhibited pain for ##redHeading##?",
      "redHeading" : "Left Shoulder",
      "sub":"Check all that apply",
      "type":"radioTiles",
      "multi": true,
      "show": true,
      "section": {
         page: "4",
         title: "ROM AND FUNCTIONAL LIMITATION",
         number: "3A"
      },
      "small": true,
      "partial": true,
      "cols": 2,
      "questions":[
         {
            "main":"Flexion",
            "dbqName":"form1[0].#subform[4].CheckBox37[36]",
            "answer":""
         },
         {
            "main":"Abduction",
            "dbqName":"form1[0].#subform[4].CheckBox37[37]",
            "answer":""
         },
         {
            "main":"Internal Rotation",
            "dbqName":"form1[0].#subform[4].CheckBox37[38]",
            "answer":""
         },
         {
            "main":"External Rotation",
            "dbqName":"form1[0].#subform[4].CheckBox37[39]",
            "answer":""
         },
         {
            "main":"None",
            "dbqName":"pass_this_question",
            "partialField": true,
            "answer":""
         }             
      ],
      "answer":""
   },
   {
      "question":"Is there evidence of pain for ##redHeading##?",
      "redHeading":"Right Shoulder",
      "sub":"",
      "type":"radioTiles",
      "multi": true,
      "partial": true,
      "show": true,
      "section": {
         page: "4",
         title: "ROM AND FUNCTIONAL LIMITATION",
         number: "3A"
      },
      "small": true,
      "cols": 3,
      "questions":[
         {
            "main":"Weight-bearing",
            "dbqName":"form1[0].#subform[4].CheckBox37[48],form1[0].#subform[4].#area[43].CheckBox37[64]",
            "answer":""
         },
         {
            "main":"Active motion",
            "dbqName":"form1[0].#subform[4].CheckBox37[51],form1[0].#subform[4].#area[43].CheckBox37[64]",
            "answer":""
         },
         {
            "main":"Non-weight bearing",
            "dbqName":"form1[0].#subform[4].CheckBox37[49],form1[0].#subform[4].#area[43].CheckBox37[64]",
            "answer":""
         },
         {
            "main":"Passive motion",
            "dbqName":"form1[0].#subform[4].CheckBox37[50],form1[0].#subform[4].#area[43].CheckBox37[64]",
            "answer":""
         },
         {
            "main":"On Rest/Non-movement",
            "dbqName":"form1[0].#subform[4].CheckBox37[52],form1[0].#subform[4].#area[43].CheckBox37[64]",
            "answer":""
         },
         {
            "main":"Causes functional loss",
            "dbqName":"form1[0].#subform[4].CheckBox37[53],form1[0].#subform[4].#area[43].CheckBox37[64]",
            "answer":"",
            "textarea": true,
            "textdbqName" : "form1[0].#subform[5].TextField6[135]",
            "placeholder": "describe in the functional loss",
            "textAnswer": ""
         },
         {
            "main":"Does not result in/cause functional loss",
            "dbqName":"form1[0].#subform[4].CheckBox37[54],form1[0].#subform[4].#area[43].CheckBox37[64]",
            "answer":""
         },
         {
            "main":"None",
            "partialField": true,
            "dbqName":"form1[0].#subform[4].#area[43].CheckBox37[65]",
            "answer":""
         }            
      ],
      "answer":""
   },
   {
      "question":"Is there evidence of pain for ##redHeading##?",
      "redHeading":"Left Shoulder",
      "sub":"",
      "type":"radioTiles",
      "multi": true,
      "partial": true,
      "show": true,
      "section": {
         page: "4",
         title: "ROM AND FUNCTIONAL LIMITATION",
         number: "3A"
      },
      "small": true,
      "cols": 3,
      "questions":[
         {
            "main":"Weight-bearing",
            "dbqName":"form1[0].#subform[4].CheckBox37[55],form1[0].#subform[4].#area[42].CheckBox37[62]",
            "answer":""
         },
         {
            "main":"Active motion",
            "dbqName":"form1[0].#subform[4].CheckBox37[58],form1[0].#subform[4].#area[42].CheckBox37[62]",
            "answer":""
         },
         {
            "main":"Non-weight bearing",
            "dbqName":"form1[0].#subform[4].CheckBox37[56],form1[0].#subform[4].#area[42].CheckBox37[62]",
            "answer":""
         },
         {
            "main":"Passive motion",
            "dbqName":"form1[0].#subform[4].CheckBox37[57],form1[0].#subform[4].#area[42].CheckBox37[62]",
            "answer":""
         },
         {
            "main":"On Rest/Non-movement",
            "dbqName":"form1[0].#subform[4].CheckBox37[59],form1[0].#subform[4].#area[42].CheckBox37[62]",
            "answer":""
         },
         {
            "main":"Causes functional loss",
            "dbqName":"form1[0].#subform[4].CheckBox37[60],form1[0].#subform[4].#area[42].CheckBox37[62]",
            "answer":"",
            "textarea": true,
            "textdbqName" : "form1[0].#subform[5].TextField6[134]",
            "placeholder": "describe in the functional loss",
            "textAnswer": ""
         },
         {
            "main":"Does not result in/cause functional loss",
            "dbqName":"form1[0].#subform[4].CheckBox37[61],form1[0].#subform[4].#area[42].CheckBox37[62]",
            "answer":""
         },
         {
            "main":"None",
            "partialField": true,
            "dbqName":"form1[0].#subform[4].#area[42].CheckBox37[63]",
            "answer":""
         }            
      ],
      "answer":""
   },   
   {
      "question":"Is there objective evidence of crepitus?",
      "sub":"",
      "type":"radio",
      "show": true,
      "section": {
         page: "5",
         title: "ROM AND FUNCTIONAL LIMITATION",
         number: "3A"
      },
      "questions":[
         {
            "label":"Right Shoulder",
            "title":"",
            "subMain":"",
            "sub":"",
            "options":[
               {
                  "main":"Yes",
                  "dbqName":"form1[0].#subform[5].#area[44].CheckBox37[66]",
                  "sub":""
               },
               {
                  "main":"No",
                  "dbqName":"form1[0].#subform[5].#area[44].CheckBox37[67]",
                  "sub":""
               }
            ],
            "answer":"No"
         },
         {
            "label":"Left Shoulder",
            "title":"",
            "subMain":"",
            "sub":"",
            "options":[
               {
                  "main":"Yes",
                  "dbqName":"form1[0].#subform[5].#area[45].CheckBox37[68]",
                  "sub":""
               },
               {
                  "main":"No",
                  "dbqName":"form1[0].#subform[5].#area[45].CheckBox37[69]",
                  "sub":""
               }
            ],
            "answer":"No"
         }
      ]
   },
   {
      "question":"Is there objective evidence of localized tenderness or pain on palpation of the joint or associated soft tissue for ##redHeading##?",
      "redHeading": "Right Shoulder",
      "sub":"",
      "type":"yesno",
      "show": true,
      "section": {
         page: "5",
         title: "ROM AND FUNCTIONAL LIMITATION",
         number: "3A"
      },
      "presidence":"Yes",
      "maxLength":135,
      "ref":0,
      "dbqName_yes":"form1[0].#subform[5].#area[48].CheckBox37[74]",
      "dbqName_no":"form1[0].#subform[5].#area[48].CheckBox37[75]",
      "answer":"",
      "istext": true,
      "textarea": false,
      "placeholder": "Please explain. Include location, severity, and relationship to condition(s)",
      "textdbqName":"form1[0].#subform[5].TextField6[137]",
      "textanswer":""
   },   
   {
      "question":"Is there objective evidence of localized tenderness or pain on palpation of the joint or associated soft tissue for ##redHeading##?",
      "redHeading": "Left Shoulder",
      "sub":"",
      "type":"yesno",
      "show": true,
      "section": {
         page: "5",
         title: "ROM AND FUNCTIONAL LIMITATION",
         number: "3A"
      },
      "presidence":"Yes",
      "maxLength":135,
      "ref":0,
      "dbqName_yes":"form1[0].#subform[5].#area[49].CheckBox37[76]",
      "dbqName_no":"form1[0].#subform[5].#area[49].CheckBox37[77]",
      "answer":"",
      "istext": true,
      "textarea": false,
      "placeholder": "Please explain. Include location, severity, and relationship to condition(s)",
      "textdbqName":"form1[0].#subform[5].TextField6[136]",
      "textanswer":""
   },
   {
      "question":"Hawkins' Impingement Test",
      "sub":"Forward flex the arm to 90 degrees with the elbow bent to 90 degrees. Internally rotate arm. Pain on internal rotation indicates a positive test; may signify rotator cuff tendinopathy or tear",
      "type":"radio",
      "show": true,
      "section": {
         page: "8",
         title: "ROTATOR CUFF CONDITIONS",
         number: "6A"
      },
      "questions":[
         {
            "label":"Right Shoulder",
            "title":"",
            "subMain":"",
            "sub":"",
            "options":[
               {
                  "main":"Positive",
                  "dbqName":"form1[0].#subform[8].CheckBox37[162]",
                  "sub":""
               },
               {
                  "main":"Negative",
                  "dbqName":"form1[0].#subform[8].CheckBox37[163]",
                  "sub":""
               },
               {
                  "main":"Unable to test",
                  "dbqName":"form1[0].#subform[8].CheckBox37[164]",
                  "sub":""
               },
               {
                  "main":"N/A",
                  "dbqName":"form1[0].#subform[8].CheckBox37[165]",
                  "sub":""
               }
            ],
            "answer":"N/A"
         },
         {
            "label":"Left Shoulder",
            "title":"",
            "subMain":"",
            "sub":"",
            "options":[
               {
                  "main":"Positive",
                  "dbqName":"form1[0].#subform[8].CheckBox37[180]",
                  "sub":""
               },
               {
                  "main":"Negative",
                  "dbqName":"form1[0].#subform[8].CheckBox37[181]",
                  "sub":""
               },
               {
                  "main":"Unable to test",
                  "dbqName":"form1[0].#subform[8].CheckBox37[182]",
                  "sub":""
               },
               {
                  "main":"N/A",
                  "dbqName":"form1[0].#subform[8].CheckBox37[183]",
                  "sub":""
               }
            ],
            "answer":"N/A"
         }
      ]
   },
   {
      "question":"Empty Can Test",
      "sub":"Abduct arm to 90 degrees and forward flex 30 degrees. Patient turns thumbs down and resists downward force applied by the examiner. Weakness indicates a positive test; may indicate rotator cuff pathology, including supraspinatus tendinopathy or tear",
      "type":"radio",
      "show": true,
      "section": {
         page: "8",
         title: "ROTATOR CUFF CONDITIONS",
         number: "6A"
      },
      "questions":[
         {
            "label":"Right Shoulder",
            "title":"",
            "subMain":"",
            "sub":"",
            "options":[
               {
                  "main":"Positive",
                  "dbqName":"form1[0].#subform[8].CheckBox37[168]",
                  "sub":""
               },
               {
                  "main":"Negative",
                  "dbqName":"form1[0].#subform[8].CheckBox37[169]",
                  "sub":""
               },
               {
                  "main":"Unable to test",
                  "dbqName":"form1[0].#subform[8].CheckBox37[170]",
                  "sub":""
               },
               {
                  "main":"N/A",
                  "dbqName":"form1[0].#subform[8].CheckBox37[171]",
                  "sub":""
               }
            ],
            "answer":"N/A"
         },
         {
            "label":"Left Shoulder",
            "title":"",
            "subMain":"",
            "sub":"",
            "options":[
               {
                  "main":"Positive",
                  "dbqName":"form1[0].#subform[8].CheckBox37[184]",
                  "sub":""
               },
               {
                  "main":"Negative",
                  "dbqName":"form1[0].#subform[8].CheckBox37[185]",
                  "sub":""
               },
               {
                  "main":"Unable to test",
                  "dbqName":"form1[0].#subform[8].CheckBox37[186]",
                  "sub":""
               },
               {
                  "main":"N/A",
                  "dbqName":"form1[0].#subform[8].CheckBox37[187]",
                  "sub":""
               }
            ],
            "answer":"N/A"
         }
      ]
   },
   {
      "question":"External rotation/infraspinatus strength test",
      "sub":"Patient holds arms at side with elbow flexed 90 degrees. Patient externally rotates against resistance. Weakness indicates a positive test; may be associated with infraspinatus tendinopathy or tear.",
      "type":"radio",
      "show": true,
      "section": {
         page: "8",
         title: "ROTATOR CUFF CONDITIONS",
         number: "6A"
      },
      "questions":[
         {
            "label":"Right Shoulder",
            "title":"",
            "subMain":"",
            "sub":"",
            "options":[
               {
                  "main":"Positive",
                  "dbqName":"form1[0].#subform[8].CheckBox37[172]",
                  "sub":""
               },
               {
                  "main":"Negative",
                  "dbqName":"form1[0].#subform[8].CheckBox37[173]",
                  "sub":""
               },
               {
                  "main":"Unable to test",
                  "dbqName":"form1[0].#subform[8].CheckBox37[174]",
                  "sub":""
               },
               {
                  "main":"N/A",
                  "dbqName":"form1[0].#subform[8].CheckBox37[175]",
                  "sub":""
               }
            ],
            "answer":"N/A"
         },
         {
            "label":"Left Shoulder",
            "title":"",
            "subMain":"",
            "sub":"",
            "options":[
               {
                  "main":"Positive",
                  "dbqName":"form1[0].#subform[8].CheckBox37[188]",
                  "sub":""
               },
               {
                  "main":"Negative",
                  "dbqName":"form1[0].#subform[8].CheckBox37[189]",
                  "sub":""
               },
               {
                  "main":"Unable to test",
                  "dbqName":"form1[0].#subform[8].CheckBox37[190]",
                  "sub":""
               },
               {
                  "main":"N/A",
                  "dbqName":"form1[0].#subform[8].CheckBox37[191]",
                  "sub":""
               }
            ],
            "answer":"N/A"
         }
      ]
   },
   {
      "question":"Lift-off subscapularis test",
      "sub":"Patient internally rotates arm behind lower back, pushes against examiner's hand. Weakness indicates a positive test; may indicate subscapularis tendinopathy or tear.",
      "type":"radio",
      "show": true,
      "section": {
         page: "8",
         title: "ROTATOR CUFF CONDITIONS",
         number: "6A"
      },
      "questions":[
         {
            "label":"Right Shoulder",
            "title":"",
            "subMain":"",
            "sub":"",
            "options":[
               {
                  "main":"Positive",
                  "dbqName":"form1[0].#subform[8].CheckBox37[176]",
                  "sub":""
               },
               {
                  "main":"Negative",
                  "dbqName":"form1[0].#subform[8].CheckBox37[177]",
                  "sub":""
               },
               {
                  "main":"Unable to test",
                  "dbqName":"form1[0].#subform[8].CheckBox37[178]",
                  "sub":""
               },
               {
                  "main":"N/A",
                  "dbqName":"form1[0].#subform[8].CheckBox37[179]",
                  "sub":""
               }
            ],
            "answer":"N/A"
         },
         {
            "label":"Left Shoulder",
            "title":"",
            "subMain":"",
            "sub":"",
            "options":[
               {
                  "main":"Positive",
                  "dbqName":"form1[0].#subform[8].CheckBox37[192]",
                  "sub":""
               },
               {
                  "main":"Negative",
                  "dbqName":"form1[0].#subform[8].CheckBox37[193]",
                  "sub":""
               },
               {
                  "main":"Unable to test",
                  "dbqName":"form1[0].#subform[8].CheckBox37[194]",
                  "sub":""
               },
               {
                  "main":"N/A",
                  "dbqName":"form1[0].#subform[8].CheckBox37[195]",
                  "sub":""
               }
            ],
            "answer":"N/A"
         }
      ]
   },
   {
      "question":"Crank Apprehension and Relocation Test",
      "sub":"With patient supine, abduct patient's arm to 90 degrees and flex elbow 90 degrees. Pain and sense of instability with further external rotation may indicate shoulder instability.",
      "type":"radio",
      "show": true,
      "section": {
         page: "8",
         title: "SHOULDER INSTABILITY, DISLOCATION OR LABRAL PATHOLOGY",
         number: "7A"
      },
      "questions":[
         {
            "label":"Right Shoulder",
            "title":"",
            "subMain":"",
            "sub":"",
            "options":[
               {
                  "main":"Positive",
                  "dbqName":"form1[0].#subform[8].CheckBox37[204]",
                  "sub":""
               },
               {
                  "main":"Negative",
                  "dbqName":"form1[0].#subform[8].CheckBox37[205]",
                  "sub":""
               },
               {
                  "main":"Unable to test",
                  "dbqName":"form1[0].#subform[8].CheckBox37[206]",
                  "sub":""
               },
               {
                  "main":"N/A",
                  "dbqName":"form1[0].#subform[8].CheckBox37[207]",
                  "sub":""
               }
            ],
            "answer":"N/A"
         },
         {
            "label":"Left Shoulder",
            "title":"",
            "subMain":"",
            "sub":"",
            "options":[
               {
                  "main":"Positive",
                  "dbqName":"form1[0].#subform[8].CheckBox37[218]",
                  "sub":""
               },
               {
                  "main":"Negative",
                  "dbqName":"form1[0].#subform[8].CheckBox37[219]",
                  "sub":""
               },
               {
                  "main":"Unable to test",
                  "dbqName":"form1[0].#subform[8].CheckBox37[220]",
                  "sub":""
               },
               {
                  "main":"N/A",
                  "dbqName":"form1[0].#subform[8].CheckBox37[221]",
                  "sub":""
               }
            ],
            "answer":"N/A"
         }
      ]
   },
   {
      "question":"If unable to test, is shoulder instability, dislocation or labral pathology suspected for ##redHeading##?",
      "redHeading": "Right Shoulder",
      "sub":"",
      "type":"yesno",
      "show": true,
      "section": {
         page: "8",
         title: "SHOULDER INSTABILITY, DISLOCATION OR LABRAL PATHOLOGY",
         number: "7B"
      },
      "presidence":"Yes",
      "maxLength":275,
      "ref":0,
      "dbqName_yes":"form1[0].#subform[8].#area[67].CheckBox37[208]",
      "dbqName_no":"form1[0].#subform[8].#area[67].CheckBox37[209]",
      "answer":"",
      "istext": true,
      "textarea": false,
      "placeholder": "If yes, please describe",
      "textdbqName":"form1[0].#subform[8].TextField6[186]",
      "textanswer":""
   },   
   {
      "question":"If unable to test, is shoulder instability, dislocation or labral pathology suspected for ##redHeading##?",
      "redHeading": "Left Shoulder",
      "sub":"",
      "type":"yesno",
      "show": true,
      "section": {
         page: "8",
         title: "SHOULDER INSTABILITY, DISLOCATION OR LABRAL PATHOLOGY",
         number: "7B"
      },
      "presidence":"Yes",
      "maxLength":275,
      "ref":0,
      "dbqName_yes":"form1[0].#subform[8].#area[72].CheckBox37[222]",
      "dbqName_no":"form1[0].#subform[8].#area[72].CheckBox37[223]",
      "answer":"",
      "istext": true,
      "textarea": false,
      "placeholder": "If yes, please describe",
      "textdbqName":"form1[0].#subform[8].TextField6[187]",
      "textanswer":""
   },
   {
      "question":"Is there shoulder instability, dislocation or labral pathology?",
      "sub":"",
      "type":"radio",
      "show": true,
      "section": {
         page: "8",
         title: "SHOULDER INSTABILITY, DISLOCATION OR LABRAL PATHOLOGY",
         number: "7C"
      },
      "questions":[
         {
            "label":"Right Shoulder",
            "title":"",
            "subMain":"",
            "sub":"",
            "options":[
               {
                  "main":"Yes",
                  "dbqName":"form1[0].#subform[8].#area[62].CheckBox37[166]",
                  "sub":""
               },
               {
                  "main":"No",
                  "dbqName":"form1[0].#subform[8].#area[62].CheckBox37[167]",
                  "sub":""
               }
            ],
            "answer":"No"
         },
         {
            "label":"Left Shoulder",
            "title":"",
            "subMain":"",
            "sub":"",
            "options":[
               {
                  "main":"Yes",
                  "dbqName":"form1[0].#subform[8].#area[69].CheckBox37[212]",
                  "sub":""
               },
               {
                  "main":"No",
                  "dbqName":"form1[0].#subform[8].#area[69].CheckBox37[213]",
                  "sub":""
               }
            ],
            "answer":"No"
         }
      ]
   },
   {
      "question":"Does ##name## have mechanical symptoms (clicking, catching, etc.)?",
      "sub":"",
      "type":"radio",
      "show": true,
      "section": {
         page: "8",
         title: "SHOULDER INSTABILITY, DISLOCATION OR LABRAL PATHOLOGY",
         number: "7D"
      },
      "questions":[
         {
            "label":"Right Shoulder",
            "title":"",
            "subMain":"",
            "sub":"",
            "options":[
               {
                  "main":"Yes",
                  "dbqName":"form1[0].#subform[8].#area[65].CheckBox37[200]",
                  "sub":""
               },
               {
                  "main":"No",
                  "dbqName":"form1[0].#subform[8].#area[65].CheckBox37[201]",
                  "sub":""
               }
            ],
            "answer":"No"
         },
         {
            "label":"Left Shoulder",
            "title":"",
            "subMain":"",
            "sub":"",
            "options":[
               {
                  "main":"Yes",
                  "dbqName":"form1[0].#subform[8].#area[70].CheckBox37[214]",
                  "sub":""
               },
               {
                  "main":"No",
                  "dbqName":"form1[0].#subform[8].#area[70].CheckBox37[215]",
                  "sub":""
               }
            ],
            "answer":"No"
         }
      ]
   },
   {
      "question":"Are there current residuals of recurrent dislocation (subluxation) of the glenohumeral (scapulohumeral) joint for ##redHeading##?",
      "redHeading": "Right Shoulder",
      "sub":"Check all that apply",
      "type":"checkbox",
      "multi": true,
      "small": true,
      "show": true,
      "section": {
         page: "8",
         title: "SHOULDER INSTABILITY, DISLOCATION OR LABRAL PATHOLOGY",
         number: "7E"
      },
      "cols": 2,
      "questions":[
         {
            "main":"N/A",
            "dbqName":"form1[0].#subform[8].#area[66].CheckBox37[203]",
            "answer":""
         },
         {
            "main":"Infrequent episodes and guarding of movement only at shoulder level (flexion and/or abduction at 90°)",
            "dbqName":"form1[0].#subform[8].CheckBox36[185],form1[0].#subform[8].#area[66].CheckBox37[202]",
            "answer":""
         },
         {
            "main":"Frequent episodes and guarding of all arm movements",
            "dbqName":"form1[0].#subform[8].CheckBox36[186],form1[0].#subform[8].#area[66].CheckBox37[202]",
            "answer":"",
            "multi": false,
            "subAnswer":"",
            "textarea": false,
            "showSubItems": false,
            "subItems": [
               {
                  "main":"Affects range of motion",
                  "dbqName":"form1[0].#subform[8].#area[68].CheckBox37[210]",
                  "answer":""
               },
               {
                  "main":"Doesn't affect range of motion",
                  "dbqName":"form1[0].#subform[8].#area[68].CheckBox37[211]",
                  "answer":""
               }
            ],
         }           
      ],
      "answer":""
   },
   {
      "question":"Are there current residuals of recurrent dislocation (subluxation) of the glenohumeral (scapulohumeral) joint for ##redHeading##?",
      "redHeading": "Left Shoulder",
      "sub":"Check all that apply",
      "type":"checkbox",
      "multi": true,
      "small": true,
      "show": true,
      "section": {
         page: "8",
         title: "SHOULDER INSTABILITY, DISLOCATION OR LABRAL PATHOLOGY",
         number: "7E"
      },
      "cols": 2,
      "questions":[
         {
            "main":"N/A",
            "dbqName":"form1[0].#subform[8].#area[71].CheckBox37[217]",
            "answer":""
         },
         {
            "main":"Infrequent episodes and guarding of movement only at shoulder level (flexion and/or abduction at 90°)",
            "dbqName":"form1[0].#subform[8].CheckBox36[188],form1[0].#subform[8].#area[71].CheckBox37[216]",
            "answer":""
         },
         {
            "main":"Frequent episodes and guarding of all arm movements",
            "dbqName":"form1[0].#subform[8].CheckBox36[187],form1[0].#subform[8].#area[71].CheckBox37[216]",
            "answer":"",
            "multi": false,
            "subAnswer":"",
            "textarea": false,
            "showSubItems": false,
            "subItems": [
               {
                  "main":"Affects range of motion",
                  "dbqName":"form1[0].#subform[8].#area[73].CheckBox37[224]",
                  "answer":""
               },
               {
                  "main":"Doesn't affect range of motion",
                  "dbqName":"form1[0].#subform[8].#area[73].CheckBox37[225]",
                  "answer":""
               }
            ],
         }           
      ],
      "answer":""
   },
   {
      "question":"Cross-body adduction test: Passively adduct arm across the patient's body toward the contralateral shoulder",
      "sub":"Pain may indicate AC joint pathology",
      "type":"radio",
      "show": true,
      "section": {
         page: "9",
         title: "CLAVICLE, SCAPULA, ACROMIOCLAVICULAR (AC) JOINT",
         number: "8A"
      },
      "questions":[
         {
            "label":"Right Shoulder",
            "title":"",
            "subMain":"",
            "sub":"",
            "options":[
               {
                  "main":"Positive",
                  "dbqName":"form1[0].#subform[9].CheckBox37[235]",
                  "sub":""
               },
               {
                  "main":"Negative",
                  "dbqName":"form1[0].#subform[9].CheckBox37[236]",
                  "sub":""
               },
               {
                  "main":"Unable to test",
                  "dbqName":"form1[0].#subform[9].CheckBox37[237]",
                  "sub":""
               },
               {
                  "main":"N/A",
                  "dbqName":"form1[0].#subform[9].CheckBox37[238]",
                  "sub":""
               }
            ],
            "answer":"N/A"
         },
         {
            "label":"Left Shoulder",
            "title":"",
            "subMain":"",
            "sub":"",
            "options":[
               {
                  "main":"Positive",
                  "dbqName":"form1[0].#subform[9].CheckBox37[263]",
                  "sub":""
               },
               {
                  "main":"Negative",
                  "dbqName":"form1[0].#subform[9].CheckBox37[264]",
                  "sub":""
               },
               {
                  "main":"Unable to test",
                  "dbqName":"form1[0].#subform[9].CheckBox37[265]",
                  "sub":""
               },
               {
                  "main":"N/A",
                  "dbqName":"form1[0].#subform[9].CheckBox37[266]",
                  "sub":""
               }
            ],
            "answer":"N/A"
         }
      ]
   },
   {
      "question":"If unable to test, is a clavicle, scapula, acromioclavicular (AC) joint or sternoclavicular joint condition suspected for ##redHeading##?",
      "redHeading": "Right Shoulder",
      "sub":"",
      "type":"yesno",
      "show": true,
      "section": {
         page: "9",
         title: "CLAVICLE, SCAPULA, ACROMIOCLAVICULAR (AC) JOINT",
         number: "8B"
      },
      "presidence":"Yes",
      "maxLength":230,
      "ref":0,
      "dbqName_yes":"form1[0].#subform[9].#area[76].CheckBox37[239]",
      "dbqName_no":"form1[0].#subform[9].#area[76].CheckBox37[240]",
      "answer":"",
      "istext": true,
      "textarea": false,
      "placeholder": "If yes, please describe",
      "textdbqName":"form1[0].#subform[9].TextField6[189]",
      "textanswer":""
   },   
   {
      "question":"If unable to test, is a clavicle, scapula, acromioclavicular (AC) joint or sternoclavicular joint condition suspected for ##redHeading##?",
      "redHeading": "Left Shoulder",
      "sub":"",
      "type":"yesno",
      "show": true,
      "section": {
         page: "9",
         title: "CLAVICLE, SCAPULA, ACROMIOCLAVICULAR (AC) JOINT",
         number: "8B"
      },
      "presidence":"Yes",
      "maxLength":230,
      "ref":0,
      "dbqName_yes":"form1[0].#subform[9].#area[83].CheckBox37[267]",
      "dbqName_no":"form1[0].#subform[9].#area[83].CheckBox37[268]",
      "answer":"",
      "istext": true,
      "textarea": false,
      "placeholder": "If yes, please describe",
      "textdbqName":"form1[0].#subform[9].TextField6[191]",
      "textanswer":""
   },
   {
      "question":" Is there a clavicle, scapula, acromioclavicular (AC) joint, sternoclavicular joint condition or other impairment for ##redHeading##",
      "redHeading": "Right Shoulder",
      "sub":"If yes, indicate severity",
      "type":"radioTiles",
      "multi": false,
      "show": true,
      "section": {
         page: "9",
         title: "CLAVICLE, SCAPULA, ACROMIOCLAVICULAR (AC) JOINT",
         number: "8C"
      },
      "textarea": false,
      "small": true, //incase without textarea show tile
      "cols": 2,
      "questions":[
         {
            "main":"Not Observed",
            "dbqName":"form1[0].#subform[9].#area[77].CheckBox37[242]",
            "answer":"",
         },
         {
            "main":"Malunion of clavicle or scapula",
            "dbqName":"form1[0].#subform[9].CheckBox37[226],form1[0].#subform[9].#area[77].CheckBox37[241]",
            "answer":"",
         },
         {
            "main":"Nonunion of clavicle or scapula without loose movement",
            "dbqName":"form1[0].#subform[9].CheckBox37[228],form1[0].#subform[9].#area[77].CheckBox37[241]",
            "answer":"",
         },
         {
            "main":"Nonunion of clavicle or scapula with loose movement",
            "dbqName":"form1[0].#subform[9].CheckBox37[229],form1[0].#subform[9].#area[77].CheckBox37[241]",
            "answer":"",
         },
         {
            "main":"Dislocation (acromioclavicular separation or sternoclavicular dislocation)",
            "dbqName":"form1[0].#subform[9].CheckBox37[227],form1[0].#subform[9].#area[77].CheckBox37[241]",
            "answer":"",
         },
         {
            "main":"Other (Describe)",
            "dbqName":"form1[0].#subform[9].CheckBox37[230],form1[0].#subform[9].#area[77].CheckBox37[241]",
            "answer":"",
            "textarea": true,
            "maxLength":130,
            "textdbqName" : "form1[0].#subform[9].TextField6[188]",
            "placeholder": "Please describe",
            "textAnswer": ""
         }
      ],
      "answer":"",
      "textAnswer": ""
   },
   {
      "question":" Is there a clavicle, scapula, acromioclavicular (AC) joint, sternoclavicular joint condition or other impairment for ##redHeading##",
      "redHeading": "Left Shoulder",
      "sub":"If yes, indicate severity",
      "type":"radioTiles",
      "multi": false,
      "show": true,
      "section": {
         page: "9",
         title: "CLAVICLE, SCAPULA, ACROMIOCLAVICULAR (AC) JOINT",
         number: "8C"
      },
      "textarea": false,
      "small": true, //incase without textarea show tile
      "cols": 2,
      "questions":[
         {
            "main":"Not Observed",
            "dbqName":"form1[0].#subform[9].#area[84].CheckBox37[270]",
            "answer":"",
         },
         {
            "main":"Malunion of clavicle or scapula",
            "dbqName":"form1[0].#subform[9].CheckBox37[254],form1[0].#subform[9].#area[84].CheckBox37[269]",
            "answer":"",
         },
         {
            "main":"Nonunion of clavicle or scapula without loose movement",
            "dbqName":"form1[0].#subform[9].CheckBox37[256],form1[0].#subform[9].#area[84].CheckBox37[269]",
            "answer":"",
         },
         {
            "main":"Nonunion of clavicle or scapula with loose movement",
            "dbqName":"form1[0].#subform[9].CheckBox37[257],form1[0].#subform[9].#area[84].CheckBox37[269]",
            "answer":"",
         },
         {
            "main":"Dislocation (acromioclavicular separation or sternoclavicular dislocation)",
            "dbqName":"form1[0].#subform[9].CheckBox37[255],form1[0].#subform[9].#area[84].CheckBox37[269]",
            "answer":"",
         },
         {
            "main":"Other (Describe)",
            "dbqName":"form1[0].#subform[9].CheckBox37[258],form1[0].#subform[9].#area[84].CheckBox37[269]",
            "answer":"",
            "textarea": true,
            "maxLength":130,
            "textdbqName" : "form1[0].#subform[9].TextField6[190]",
            "placeholder": "Please describe",
            "textAnswer": ""
         }
      ],
      "answer":"",
      "textAnswer": ""
   },
   {
      "question":"Does the clavicle or scapula condition affect range of motion of the shoulder (glenohumeral joint)?",
      "sub":"",
      "type":"radio",
      "show": true,
      "section": {
         page: "9",
         title: "CLAVICLE, SCAPULA, ACROMIOCLAVICULAR (AC) JOINT",
         number: "8D"
      },
      "questions":[
         {
            "label":"Right Shoulder",
            "title":"",
            "subMain":"",
            "sub":"",
            "options":[
               {
                  "main":"Yes",
                  "dbqName":"form1[0].#subform[9].#area[74].CheckBox37[231]",
                  "sub":""
               },
               {
                  "main":"No",
                  "dbqName":"form1[0].#subform[9].#area[74].CheckBox37[232]",
                  "sub":""
               }
            ],
            "answer":"No"
         },
         {
            "label":"Left Shoulder",
            "title":"",
            "subMain":"",
            "sub":"",
            "options":[
               {
                  "main":"Yes",
                  "dbqName":"form1[0].#subform[9].#area[81].CheckBox37[259]",
                  "sub":""
               },
               {
                  "main":"No",
                  "dbqName":"form1[0].#subform[9].#area[81].CheckBox37[260]",
                  "sub":""
               }
            ],
            "answer":"No"
         }
      ]
   },
   {
      "question":"Is there tenderness on palpation of the AC joint?",
      "sub":"",
      "type":"radio",
      "show": true,
      "section": {
         page: "9",
         title: "CLAVICLE, SCAPULA, ACROMIOCLAVICULAR (AC) JOINT",
         number: "8E"
      },
      "questions":[
         {
            "label":"Right Shoulder",
            "title":"",
            "subMain":"",
            "sub":"",
            "options":[
               {
                  "main":"Yes",
                  "dbqName":"form1[0].#subform[9].#area[75].CheckBox37[233]",
                  "sub":""
               },
               {
                  "main":"No",
                  "dbqName":"form1[0].#subform[9].#area[75].CheckBox37[234]",
                  "sub":""
               }
            ],
            "answer":"No"
         },
         {
            "label":"Left Shoulder",
            "title":"",
            "subMain":"",
            "sub":"",
            "options":[
               {
                  "main":"Yes",
                  "dbqName":"form1[0].#subform[9].#area[82].CheckBox37[261]",
                  "sub":""
               },
               {
                  "main":"No",
                  "dbqName":"form1[0].#subform[9].#area[82].CheckBox37[262]",
                  "sub":""
               }
            ],
            "answer":"No"
         }
      ]
   },

   {
      "question":"Indicate any surgical procedures that ##name## has had performed for ##redHeading## and provide the additional information as requested?",
      "redHeading":"Right shoulder",
      "sub":"",
      "type":"radioModal",
      "multi": true,
      "partial": true,
      "show": true,
      "small": true,
      "cols": 2,
      "section": {
         page: "9",
         title: "SURGICAL PROCEDURES",
         number: "10"
      },
      "questions":[
               {
                  "main":"No surgery",
                  "dbqName":"form1[0].#subform[9].CheckBox37[288]",
                  "partialField": true,
                  "answer":"",
               }, 
               {
                  "main":"Total shoulder joint replacement",
                  "dbqName":"form1[0].#subform[9].CheckBox37[282]",
                  "answer":"",
                  "multi": false,
                  "showSubItems": false,
                  "date1": "",
                  "dbqDate1": "form1[0].#subform[9].TextField6[192]",
                  "placeholderDate1":"Date for Surgery",
                  "subItems": [
                     {
                        "main":"None",
                        "dbqName":"form1[0].#subform[9].CheckBox37[283]",
                        "colWidth": 3,
                        "answer":""
                     },
                     {
                        "main":"Intermediate degrees of residual weakness, pain, or limitation of motion",
                        "dbqName":"form1[0].#subform[9].CheckBox37[284]",
                        "colWidth": 9,
                        "answer":""
                     },
                     {
                        "main":"Other",
                        "dbqName":"form1[0].#subform[9].CheckBox37[285]",
                        "colWidth": 3,
                        "subItemLinked": true,
                        "answer":""
                     },
                     {
                        "main":"Chronic residuals consisting of severe painful motion or weakness",
                        "dbqName":"form1[0].#subform[9].CheckBox37[286]",
                        "colWidth": 9,
                        "answer":""
                     }
                     
                  ],
                  "subAnswer":"",
                  "subItemsLabel" :"Residuals",
                  "subItemOther": false,
                  "textOther": "",
                  "dbqNameOther": "form1[0].#subform[9].TextField6[193]",
                  "placeholderOther":"Other residuals describe",
               },
               {
                  "main":"Arthroscopic or other shoulder surgery",
                  "dbqName":"form1[0].#subform[9].CheckBox37[287]",
                  "answer":"",
                  "multi": false,
                  "showSubItems": false,
                  "text1": "",
                  "dbqName1": "form1[0].#subform[9].TextField6[195]",
                  "placeholder1":"Type of surgery",
                  "date1": "",
                  "dbqDate1": "form1[0].#subform[9].TextField6[194]",
                  "placeholderDate1":"Date for Surgery",
                  "text2": "",
                  "dbqName2": "form1[0].#subform[9].TextField6[196]",
                  "placeholder2":"Describe residuals",
               },  
                                      
            ],
            "answer":""
   },
   
   {
      "question":"Indicate any surgical procedures that ##name## has had performed for ##redHeading## and provide the additional information as requested?",
      "redHeading":"Left shoulder",
      "sub":"",
      "type":"radioModal",
      "multi": true,
      "partial": true,
      "show": true,
      "small": true,
      "cols": 2,
      "section": {
         page: "9",
         title: "SURGICAL PROCEDURES",
         number: "10"
      },
      "questions":[
               {
                  "main":"No surgery",
                  "dbqName":"form1[0].#subform[9].CheckBox37[295]",
                  "partialField": true,
                  "answer":"",
               },  
               {
                  "main":"Total shoulder joint replacement",
                  "dbqName":"form1[0].#subform[9].CheckBox37[289]",
                  "answer":"",
                  "multi": false,
                  "showSubItems": false,
                  "date1": "",
                  "dbqDate1": "form1[0].#subform[9].TextField6[197]",
                  "placeholderDate1":"Date for Surgery",
                  "subItems": [
                     {
                        "main":"None",
                        "dbqName":"form1[0].#subform[9].CheckBox37[290]",
                        "colWidth": 3,
                        "answer":""
                     },
                     {
                        "main":"Intermediate degrees of residual weakness, pain, or limitation of motion",
                        "dbqName":"form1[0].#subform[9].CheckBox37[291]",
                        "colWidth": 9,
                        "answer":""
                     },
                     {
                        "main":"Other",
                        "dbqName":"form1[0].#subform[9].CheckBox37[292]",
                        "colWidth": 3,
                        "subItemLinked": true,
                        "answer":""
                     },
                     {
                        "main":"Chronic residuals consisting of severe painful motion or weakness",
                        "dbqName":"form1[0].#subform[9].CheckBox37[293]",
                        "colWidth": 9,
                        "answer":""
                     }
                     
                  ],
                  "subAnswer":"",
                  "subItemsLabel" :"Residuals",
                  "subItemOther": false,
                  "textOther": "",
                  "dbqNameOther": "form1[0].#subform[9].TextField6[198]",
                  "placeholderOther":"Other residuals describe",
               },
               {
                  "main":"Arthroscopic or other shoulder surgery",
                  "dbqName":"form1[0].#subform[9].CheckBox37[294]",
                  "answer":"",
                  "multi": false,
                  "showSubItems": false,
                  "text1": "",
                  "dbqName1": "form1[0].#subform[9].TextField6[200]",
                  "placeholder1":"Type of surgery",
                  "date1": "",
                  "dbqDate1": "form1[0].#subform[9].TextField6[199]",
                  "text2": "",
                  "dbqName2": "form1[0].#subform[9].TextField6[201]",
                  "placeholder2":"Describe residuals",
               },
                                     
            ],
            "answer":""
   },
   
   {
      "question":"Additional Comments",
      "sub":"",
      "optional": true,
      "type":"textarea",
      "show": true,
      "section": {
         page: "11",
         title: "REMARKS",
         number: "16A"
      },
      "options":[],
      "dbqName":"form1[0].#subform[11].TextField6[209]",
      "answer":""
   }
]

export default shoulder_questions;